import { combineReducers } from 'redux';
import { reducerCreator } from '../util/redux-tool';
import { actionType as type } from './action';
import createCommonReducer from './commonReducer';

export default history =>
  combineReducers({
    ...createCommonReducer(history),
    feedbackList: reducerCreator(
      {
        list: [],
        total: 0,
        unReadList: [],
      },
      [type.initFeedbackList],
    ),
    customerFaqs: reducerCreator(
      {
        list: [],
        total: 0,
      },
      [type.initCustomerFaqs],
    ),
  });
